import './instrument'; // DOIT être le premier import — initialise Sentry avant tout
import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';

// Fallback UI affiché par Sentry.ErrorBoundary en cas d'erreur critique
const ErrorFallback = ({ error, resetError }) => (
  <div style={{ minHeight: '100vh', background: '#0f172a', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', flexDirection: 'column', gap: '1rem', padding: '2rem', textAlign: 'center' }}>
    <div style={{ fontSize: '3rem' }}>⚠️</div>
    <h2 style={{ margin: 0 }}>Une erreur est survenue</h2>
    <p style={{ color: '#64748b', maxWidth: '400px', margin: 0 }}>
      {error?.message || 'Erreur inattendue'}
    </p>
    <button
      onClick={() => window.location.reload()}
      style={{ background: 'linear-gradient(135deg,#3b82f6,#2563eb)', color: 'white', border: 'none', borderRadius: '0.5rem', padding: '0.75rem 1.5rem', cursor: 'pointer', fontWeight: '600', marginTop: '0.5rem' }}>
      🔄 Recharger l'application
    </button>
  </div>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={ErrorFallback} showDialog>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// Service Worker PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
